import { Subject, from, of } from "rxjs";
import { debounceTime, filter, switchMap, tap, catchError } from "rxjs/operators";
import axios from "../apis/httpClient";

/**
 * Creates a reusable Zendesk ID validation pipeline using RxJS.
 *
 * @param {React.Component} component - The React class component instance to update state on.
 * @returns {{ onSearch$: Subject, cleanup: Function }}
 */
export function createZendeskIdValidator(component) {
  const onSearch$ = new Subject();

  const subscription = onSearch$
    .pipe(
      tap((zendeskId) => {
        if (!zendeskId) {
          component.setState({
            zendeskIDStatus: "",
            existApplicant: false,
            existZendeskID: false,
          });
        } else {
          component.setState({ zendeskIDStatus: "loading" });
        }
        component.setState({ zendeskID: zendeskId });
      }),
      debounceTime(450),
      filter(Boolean),
      switchMap((zendeskId) =>
        from(axios.get(`/zendesk/ticket/${zendeskId}/check`)).pipe(
          catchError((e) => {
            console.error("Zendesk ID check failed:", e);
            component.setState({
              zendeskIDStatus: "delete",
              existZendeskID: false,
              existApplicant: false,
            });
            return of(null);
          }),
        ),
      ),
      filter(Boolean),
    )
    .subscribe({
      next: ({ data: { zendesk, applicant } }) => {
        component.setState({ existApplicant: applicant, existZendeskID: zendesk });
        if (zendesk) {
          component.setState({ zendeskIDStatus: "check" });
        } else {
          component.setState({ zendeskIDStatus: "delete" });
        }
      },
      error: (e) => {
        console.error("Zendesk ID validation stream error:", e);
        component.setState({
          zendeskIDStatus: "delete",
          existZendeskID: false,
          existApplicant: false,
        });
      },
    });

  function cleanup() {
    subscription.unsubscribe();
  }

  return { onSearch$, cleanup };
}
